document.addEventListener('DOMContentLoaded', function () {
  const volumeInput = document.getElementById('volume');
  const volumeToggle = document.getElementById('volumeToggle');
  const nitratesInput = document.getElementById('nitrates');
  const desiredNitratesInput = document.getElementById('desiredNitrates');

  const toggleTreatmentButton = document.getElementById('toggleTreatmentButton');
  const treatmentFields = document.getElementById('treatmentFields');

  const originalDoseInput = document.getElementById('originalDose');
  const originalNitrateInput = document.getElementById('originalNitrate');
  const weeksInput = document.getElementById('weeks');
  const additionalIncreaseInput = document.getElementById('additionalIncrease');

  const calculateButton = document.getElementById('calculateButton');
  const errorMessageDiv = document.getElementById('errorMessage');
  const productInfo = document.getElementById('productInfo');
  const additionalDoseText = document.getElementById('additionalDoseText');

  if (
    !volumeInput ||
    !volumeToggle ||
    !nitratesInput ||
    !desiredNitratesInput ||
    !toggleTreatmentButton ||
    !treatmentFields ||
    !calculateButton ||
    !errorMessageDiv ||
    !productInfo ||
    !additionalDoseText
  ) {
    console.error('Biopellet calculator: required elements not found.');
    return;
  }

  function updateVolumePlaceholder() {
    volumeInput.placeholder = volumeToggle.checked
      ? 'Enter volume in liters'
      : 'Enter volume in gallons';
  }

  function setTreatmentFieldsVisible(visible) {
    treatmentFields.classList.toggle('show', visible);
    toggleTreatmentButton.textContent = visible
      ? 'Hide treatment details'
      : 'Already treating your reef with biopellets?';
  }

  function showError(message) {
    errorMessageDiv.textContent = message;
    errorMessageDiv.style.display = 'block';
  }

  function clearError() {
    errorMessageDiv.textContent = '';
    errorMessageDiv.style.display = 'none';
  }

  function showResult(message) {
    additionalDoseText.textContent = message;
    productInfo.style.display = 'block';
  }

  function clearResult() {
    additionalDoseText.textContent = '';
    productInfo.style.display = 'none';
  }

  function calculateBiopelletDose() {
    clearError();
    clearResult();

    const volume = parseFloat(volumeInput.value);
    const nitrates = parseFloat(nitratesInput.value);
    const desiredNitrates = parseFloat(desiredNitratesInput.value);
    const isLiters = volumeToggle.checked;
    const treatmentFieldsVisible = treatmentFields.classList.contains('show');

    let weeks = 0;
    let additionalIncrease = 0;
    let originalDose = null;
    let originalNitrate = null;

    if (treatmentFieldsVisible) {
      weeks = parseInt(weeksInput.value, 10);
      additionalIncrease = parseFloat(additionalIncreaseInput.value);
      originalDose = parseFloat(originalDoseInput.value);
      originalNitrate = parseFloat(originalNitrateInput.value);

      if (isNaN(weeks)) weeks = 0;
      if (isNaN(additionalIncrease)) additionalIncrease = 0;
    }

    let errorMsg = '';

    if (isNaN(volume) || volume <= 0) {
      errorMsg += 'Volume must be a positive number. ';
    }

    if (isNaN(nitrates) || nitrates < 0) {
      errorMsg += 'Current nitrate levels must be a non-negative number. ';
    }

    if (isNaN(desiredNitrates) || desiredNitrates < 0 || desiredNitrates > nitrates) {
      errorMsg += 'Desired nitrate level must be a non-negative number and less than or equal to current nitrate level. ';
    }

    if (treatmentFieldsVisible && (isNaN(weeks) || weeks < 0 || !Number.isInteger(weeks))) {
      errorMsg += 'Weeks must be a non-negative integer. ';
    }

    if (treatmentFieldsVisible && (isNaN(additionalIncrease) || additionalIncrease < 0)) {
      errorMsg += 'Additional increase must be a non-negative number. ';
    }

    if (treatmentFieldsVisible && (isNaN(originalDose) || originalDose <= 0)) {
      errorMsg += 'Original dose must be a positive number. ';
    }

    if (treatmentFieldsVisible && (isNaN(originalNitrate) || originalNitrate < 0)) {
      errorMsg += 'Original nitrate level must be a non-negative number. ';
    }

    if (errorMsg) {
      showError(errorMsg.trim());
      return;
    }

    const volumeGallons = isLiters ? volume / 3.78541 : volume;
    const nitrateDifference = nitrates - desiredNitrates;

    let initialDoseCups = 0;
    let additionalDoseWeekly = 0;

    if (!treatmentFieldsVisible) {
      const baseDoseCups = volumeGallons / 50;
      initialDoseCups = nitrates < 50 ? baseDoseCups / 2 : baseDoseCups;

      if (nitrateDifference > 0 && nitrates > 0) {
        additionalDoseWeekly = (initialDoseCups * 0.1) * (nitrateDifference / nitrates);
        additionalDoseWeekly = Math.max(0, Math.min(additionalDoseWeekly, initialDoseCups * 0.2));
      }
    } else {
      initialDoseCups = originalDose;
      const doseMultiplier = weeks <= 3 ? 0.05 : 0.1;
      const baseWeeklyDose = (doseMultiplier * originalDose) + additionalIncrease;

      if (nitrateDifference > 0) {
        const comparisonNitrate = originalNitrate || nitrates || 1;
        const adjustment = (originalDose * doseMultiplier) * (nitrateDifference / comparisonNitrate);
        const maxAdjustment = originalDose * 0.2;
        additionalDoseWeekly = baseWeeklyDose + Math.min(adjustment, maxAdjustment);
      } else {
        additionalDoseWeekly = baseWeeklyDose;
      }
    }

    let message = '';

    if (!treatmentFieldsVisible && initialDoseCups > 0) {
      if (nitrateDifference <= 0) {
        message =
          'Biopellet Dosing Results:\n' +
          'Initial Dose: ' + initialDoseCups.toFixed(2) + ' cups\n' +
          'No additional dosing needed. Desired nitrate level (' + desiredNitrates + ' ppm) already met or exceeded.';
      } else {
        message =
          'Biopellet Dosing Results:\n' +
          'Initial Dose: ' + initialDoseCups.toFixed(2) + ' cups\n' +
          'Add ' + additionalDoseWeekly.toFixed(2) + ' cups per week to reach ' + desiredNitrates + ' ppm.';
      }
    } else if (treatmentFieldsVisible) {
      if (nitrateDifference <= 0) {
        message =
          'Biopellet Dosing Results (Week ' + weeks + '):\n' +
          'Current Dose: ' + initialDoseCups.toFixed(2) + ' cups\n' +
          'No additional dosing needed. Desired nitrate level (' + desiredNitrates + ' ppm) already met or exceeded.';
      } else {
        const earlyTreatmentNote =
          weeks <= 3
            ? '\nNote: Since you are in the early stages of treatment (3 weeks or less), increase dosing gradually and monitor nutrient levels closely.'
            : '';

        message =
          'Biopellet Dosing Results (Week ' + weeks + '):\n' +
          'Current Dose: ' + initialDoseCups.toFixed(2) + ' cups\n' +
          'Add ' + additionalDoseWeekly.toFixed(2) + ' cups per week to reach ' + desiredNitrates + ' ppm.' +
          earlyTreatmentNote;
      }
    } else {
      message = 'Biopellet Dosing Results:\nNo additional dosing is needed at this time.';
    }

    showResult(message);
  }

  volumeToggle.addEventListener('change', updateVolumePlaceholder);

  toggleTreatmentButton.addEventListener('click', function () {
    setTreatmentFieldsVisible(!treatmentFields.classList.contains('show'));
  });

  calculateButton.addEventListener('click', calculateBiopelletDose);

  updateVolumePlaceholder();
  setTreatmentFieldsVisible(false);
});